const init = { menu:[], orders:[], loading:false };
export const canteenReducer = (state=init, action) => {
  switch(action.type) {
    case "MENU_REQUEST":    return { ...state, loading:true };
    case "MENU_SUCCESS":    return { ...state, loading:false, menu: action.payload };
    case "MENU_FAIL":       return { ...state, loading:false };
    case "ORDERS_SUCCESS":  return { ...state, orders: action.payload };
    default: return state;
  }
};
